module.exports = __webpack_public_path__ + "img/banner1.2425758f.jpg";